import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Text, Title } from '@/components/Typography';
import { useRosaResultContext } from '../context';
import { TaskItem } from './TaskItem';
import * as S from './styles';

export function ActionPlans() {
	const {
		rosaResult: { action_plans }
	} = useRosaResultContext();

	return (
		<Row gutter={[0, 20]} hidden={action_plans?.length === 0}>
			<Col xs={24}>
				<Title level={3}>{I18n.get('Action plan')}</Title>
			</Col>
			<Col xs={24}>
				<Row gutter={[0, 30]}>
					{action_plans?.map(({ id, title, responsible, deadline, description, tasks }: any) => {
						return (
							<Col key={id} span={24}>
								<S.RowCustomer justify="center">
									<Col span={24}>
										<Row justify="space-between">
											<S.TableTitle>
												<Title level={5}>{title}</Title>
											</S.TableTitle>
										</Row>
										<Row>
											<Col span={12}>
												<Row>
													<S.TableTitle span={24} $hasColor>
														<Text>{I18n.get('Responsible')}</Text>
													</S.TableTitle>
													<S.TableDescription>{responsible}</S.TableDescription>
												</Row>
												<Row>
													<S.TableTitle span={24} $hasColor>
														<Text>{I18n.get('Deadline')}</Text>
													</S.TableTitle>
													<S.TableDescription span={24}>
														<Row justify="space-between" align="middle">
															<Col xl={11} xxl={12}>
																{deadline.remaining_days}{' '}
																<Text>{deadline.remaining_days_text}</Text>
															</Col>
															<Col>
																<S.DateComponent>
																	<Row>
																		<Col>{deadline.day}</Col>
																		<Col>{deadline.month}</Col>
																		<Col>{deadline.year}</Col>
																	</Row>
																</S.DateComponent>
															</Col>
														</Row>
													</S.TableDescription>
												</Row>
											</Col>
											<Col span={12}>
												<Row>
													<S.TableTitle span={24} $hasColor $hasBorder>
														<Text>{I18n.get('Description')}</Text>
													</S.TableTitle>
												</Row>
												<Row style={{ height: '100%' }}>
													<S.TableDescription span={24} $customPadding="20px 38px" $hasBorder>
														{description}
													</S.TableDescription>
												</Row>
											</Col>
										</Row>
										<Row>
											<Col span={24}>
												<Row justify="center">
													<S.TableTitle $hasColor span={24}>
														<Text>{I18n.get('Tasks')}</Text>
													</S.TableTitle>
													<S.TableListDescription lg={24} xl={22}>
														{tasks?.length > 0
															? tasks?.map((task: any) => (
																	<TaskItem key={task.id} task={task} />
															  ))
															: 'N/A'}
													</S.TableListDescription>
												</Row>
											</Col>
										</Row>
									</Col>
								</S.RowCustomer>
							</Col>
						);
					})}
				</Row>
			</Col>
		</Row>
	);
}
